import { graphql } from 'gatsby';
import { Box, Heading } from 'lucid-components-react';
import React from 'react';

import LucidContainer from 'components/lucid-container/lucid-container';
import NineteenCta, {
  nineteenCtaThemes
} from 'components/nineteen/nineteen-cta/nineteen-cta';
import {
  Drupal_FieldParagraphNineteenBannerFieldNineteenTextCta,
  Drupal_ParagraphNineteenBanner,
  Drupal_ParagraphNineteenTextCta
} from 'generated/graphql';
import { Text } from 'theme/typography';
import { LucidTheme } from 'types/types';

interface Props {
  entity: Drupal_ParagraphNineteenBanner;
}

const NineteenBanner = ({
  entity: { fieldHeader, fieldText, fieldNineteenTextCta }
}: Props) => (
    /* eslint-disable-next-line react/jsx-indent */
    <Box
      as="section"
      css={theme => ({
        padding: `${theme.space[7]}px 0`,
        backgroundColor: theme.colors.indigo[100],
        [`@media screen and (min-width: ${theme.breakpoints.tablet})`]: {
          padding: `${theme.space[8]}px 0`
        }
      })}
    >
      <LucidContainer>
        <Box maxWidth="40rem">
          <Heading as="h2" color="white" mb={4} variant="subheadS">
            {fieldHeader}
          </Heading>
          <Text
            css={(theme: LucidTheme) => ({
              color: theme.colors.white,
              maxWidth: '40rem'
            })}
            textStyles="bodySmall"
          >
            {fieldText}
          </Text>
          {(fieldNineteenTextCta as Drupal_FieldParagraphNineteenBannerFieldNineteenTextCta[]).map(
            ({ entity }, index) => {
              const {
                entityId,
                fieldHeading,
                fieldSingleCta
              } = entity as Drupal_ParagraphNineteenTextCta;
              const isPrimary = index % 2 == 0;
              return (
                <Text
                  key={entityId}
                  css={(theme: LucidTheme) => ({ color: theme.colors.white })}
                  textStyles="bodySmall"
                >
                  {fieldHeading}
                  {fieldSingleCta && (
                    <NineteenCta
                      inverse
                      entity={fieldSingleCta.entity!}
                      primary={isPrimary}
                      theme={nineteenCtaThemes.inline}
                    />
                  )}
                </Text>
              );
            }
          )}
        </Box>
      </LucidContainer>
    </Box>
  );

export default NineteenBanner;

export const query = graphql`
  fragment nineteenBanner on Drupal_ParagraphNineteenBanner {
    fieldHeader
    fieldText
    fieldNineteenTextCta {
      entity {
        ...nineteenTextCta
      }
    }
  }
`;
